module.exports = __webpack_public_path__ + "202ef0062ccfef9aa5aafc421b67170f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/studio2.jpg
// module id = 183
// module chunks = 0